import environment from '@department-of-veterans-affairs/platform-utilities/environment';
import { RepresentativeType } from './constants';
import manifest from './manifest.json';

/* eslint-disable camelcase */

export const sortOptions = {
  distance_asc: 'Distance (closest to farthest)',
  first_name_asc: 'First name (A - Z)',
  first_name_desc: 'First name (Z - A)',
  last_name_asc: 'Last name (A - Z)',
  last_name_desc: 'Last name (Z - A)',
};

export const searchAreaOptions = {
  '5': '5 miles',
  '10': '10 miles',
  '25': '25 miles',
  '50': '50 miles',
  '100': '100 miles',
  '200': '200 miles',
  'Show all': 'Show all',
};

/*
 * Toggle true for local development
 */
export const useStagingDataLocally = true;

const baseUrl =
  useStagingDataLocally && environment.BASE_URL === 'http://localhost:3001'
    ? 'https://staging-api.va.gov'
    : environment.API_URL;

let endpoints = {
  fetchVSOReps: '/services/veteran/v0/vso_accredited_representatives',
  fetchOtherReps: '/services/veteran/v0/other_accredited_representatives',
  fetchOrganizationsEndpoint:
    '/representation_management/v0/accredited_organizations',
  flagReps: '/representation_management/v0/flag_accredited_representatives',
};

let typeMapping = {};

export const getEndpointOptions = () => endpoints;

export const getApiType = type => typeMapping[type] || type;

export const setRepSearchEndpointsFromFlag = enabled => {
  if (enabled) {
    endpoints = {
      ...endpoints,
      fetchVSOReps: '/representation_management/v0/accredited_individuals',
      fetchOtherReps: '/representation_management/v0/accredited_individuals',
    };
    typeMapping = {
      veteran_service_officer: 'representative',
      claim_agents: 'claims_agent',
    };
  } else {
    endpoints = {
      ...endpoints,
      fetchVSOReps: '/services/veteran/v0/vso_accredited_representatives',
      fetchOtherReps: '/services/veteran/v0/other_accredited_representatives',
    };
    typeMapping = {};
  }
};

/**
 * Build requestUrl and settings for api calls
 *  * @param endpoint {String} eg '/vso_accredited_representatives'
 * @returns {requestUrl, apiSettings}
 */
export const getApi = endpoint => {
  const requestUrl = `${baseUrl}${endpoint}`;

  const csrfToken = localStorage.getItem('csrfToken');

  const apiSettings = {
    mode: 'cors',
    method: 'GET',

    headers: {
      'X-Key-Inflection': 'camel',
      'Sec-Fetch-Mode': 'cors',
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken,

      // Pull app name directly from manifest since this config is defined
      // before startApp, and using window.appName here would result in
      // undefined for all requests that use this config.
      'Source-App-Name': manifest.entryName,
    },
  };

  return { requestUrl, apiSettings };
};

export const representativeTypes = {
  [RepresentativeType.VETERAN_SERVICE_OFFICER]: 'veteran_service_officer',
  [RepresentativeType.ATTORNEY]: 'attorney',
  [RepresentativeType.CLAIM_AGENTS]: 'claim_agents',
};
